import { Item, ItemDetail } from "../../../common/item/ItemDetailViewSection";
import ItemsDetailViewSection, { ItemsDetail } from "../../../common/item/ItemsDetailViewSection";
import React from "react";
import { Data } from "../../../store/pos/types";
import { PosInterfaces } from "../posEdit/PosConstants";
import moment from "moment";
import { Data as PosSoftwareData } from "../../../store/possoftware/types";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../store";

interface PosViewDetailProps {
  posData: Data;
}

const formatSoftwareVersions = (items: string[]) =>
  items.reduceRight((i, x) => `(${x}) ${i}`, "");

const timeDiff = (diff: number): string =>
  ((diff / 1000 / 60 / 60) as unknown) as string;

const commaSeparated = (items: string[]) => {
  return items
    .reduceRight((acc, curr) => {
      return `${curr}, ${acc}`;
    }, "")
    .trim()
    .slice(0, -1);
};

const softwareDisplayText = (option: PosSoftwareData | undefined) => {
  if (option) {
    return `${option.attributes.ProviderIdentification} - ${
      option.attributes.ApplicationName
    } - Versions: ${formatSoftwareVersions(
      option.attributes.SoftwareVersion
    )}`;
  }

  return "";
};

const PosViewDetail = (props: PosViewDetailProps) => {
  const { attributes: at } = props.posData;
  const posSoftwareState = useSelector(
    (state: ApplicationState) => state.posSoftware
  );
  const posSoftware = posSoftwareState?.data?.data || ([] as PosSoftwareData[]);

  const posInterface: Item[] = [
    {
      fieldName: "Interface",
      fieldValue: at.Interface,
    },
    {
      fieldName: "POS Description",
      fieldValue: at.POSDesc,
    },
    {
      fieldName: "Print On POS",
      fieldValue: at.PrintOnPOS,
    },
    {
      fieldName: "Print On Terminal",
      fieldValue: at.PrintOnTerminal,
    },
  ];

  const posInfo: Item[] = [];

  const posData: ItemDetail[] = [
    {
      sectionName: "Pos Interface",
      itemData: posInterface,
    },
    {
      sectionName: "Pos Details",
      itemData: posInfo,
    },
  ];

  if (at.Interface === PosInterfaces.NEXO) {
    posInfo.push({
      fieldName: "POS is allowed to pair with the following POI Devices",
      fieldValue: at.POIID,
    });

    const posSoftwarePresentation = posSoftware.filter(
      (option) => option.id === at.POSSoftware
    )[0];
    posInfo.push({
      fieldName: "POS Software",
      fieldValue: softwareDisplayText(posSoftwarePresentation),
    });
    posInfo.push({
      fieldName: "POS is currently paired with POI Device",
      fieldValue: at.TID,
    });
    posInfo.push({
      fieldName: "POS Local Time",
      fieldValue: at.TimeDiff ? timeDiff(at.TimeDiff) : "",
    });
    posInfo.push({
      fieldName: "Last Logout at",
      fieldValue: at.LoggedOut
        ? moment(at.LoggedOut).format("DD MMM YYYY hh:mm:ss a")
        : "Start-up",
    });
    posInfo.push({
      fieldName: "Terminal Environment",
      fieldValue: at.TerminalEnvironment,
    });
    posInfo.push({
      fieldName: "Sale Capabilities",
      fieldValue: commaSeparated(at.SaleCapabilities || []),
    });
    posInfo.push({
      fieldName: "Totals Group ID",
      fieldValue: at.TotalsGroupID,
    });
    posInfo.push({
      fieldName: "Operator ID",
      fieldValue: at.OperatorID,
    });
    posInfo.push({
      fieldName: "Shift Number",
      fieldValue: at.ShiftNumber,
    });
  }

  if (at.Interface === PosInterfaces.OPI) {
    posInfo.push({
      fieldName: "POI Device ID",
      fieldValue: at.TID,
    });
    posInfo.push({
      fieldName: "Site ID",
      fieldValue: at.SiteId,
    });
    posInfo.push({
      fieldName: "Workstation Number",
      fieldValue: at.WSNo,
    });
    posInfo.push({
      fieldName: "POS is currently paired with POI Device",
      fieldValue: at.TID,
    });
  }

  return (
    <ItemsDetailViewSection
      sectionName="POS Info"
      itemsData={posData}
      lastItem
    />
  );
};

export default PosViewDetail